<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M20.6152 6.37305H9.61523C5.90195 6.37305 3.11523 9.05808 3.11523 12.873"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.61523 19.373H14.6152C18.3285 19.373 21.1152 16.688 21.1152 12.873"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6152 3.87305C18.6152 3.87305 21.1152 5.71427 21.1152 6.37307C21.1152 7.03187 18.6152 8.87305 18.6152 8.87305"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.61521 16.873C5.61521 16.873 3.11524 18.7142 3.11523 19.373C3.11522 20.0318 5.61523 21.873 5.61523 21.873"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>